import React from "react";
import "./Spinner.scss";

const Spinner: React.FC = () => {
  return <span className="loader"></span>;
};

export default Spinner;
